export default __webpack_public_path__ + "static/media/no-chat-open.7ed55af0.svg";